<template>
  <div>
    <v-sheet
      outlined
      :color="error || errorImage ? 'red' : undefined"
      class="rounded-lg"
    >
      <v-card
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        outlined
        class="rounded-lg"
        min-height="290px"
        :class="{ 'grey lighten-2': dragover }"
      >
        <v-container
          style="min-height: 289px"
          class="d-flex flex-column align-center justify-space-between rounded-lg"
        >
          <v-btn
            :color="urlImage ? 'red' : 'grey100'"
            class="align-self-end"
            icon
            @click="deleteImage()"
          >
            <v-icon class="material-icons-outlined" size="35px">delete</v-icon>
          </v-btn>
          <div v-if="!urlImage" class="mb-4">
            <v-icon
              :class="dragover ? 'mt-2, mb-6' : 'mt-5'"
              class="material-icons-outlined"
              size="80px"
              :color="!dragover ? 'primary200' : 'primary'"
              >file_upload</v-icon
            >
            <div class="primary200--text font-weight-bold">
              {{ t("dragImage") }}
            </div>
          </div>
          <v-container v-else class="mb-4">
            <v-img :max-height="height" width="100%" :src="urlImage"></v-img>
          </v-container>

          <sc-btn
            type="file"
            max-width="180px"
            outlined
            @click="onButtonClick"
            >{{ t("btnUpload") }}</sc-btn
          >
        </v-container>
        <label class="error--text caption" v-if="error">{{
          $t("sc.required")
        }}</label>
        <input
          ref="uploader"
          class="d-none"
          type="file"
          accept="image/*"
          @change="onFileChanged"
        />
      </v-card>
    </v-sheet>
    <label v-if="!errorImage" class="caption font-weight-medium">{{
      messages
    }}</label>
    <label v-else class="caption font-weight-medium error--text">{{ messages }}</label>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, File],
    keyName: String,
    height: String,
    messages: String,
    maxImageSize: {
      default: 1,
      type: Number,
    },
    maxImageHeight: {
      required: true,
      type: Number,
    },
    maxImageWidth: {
      required: true,
      type: Number,
    },
  },
  data: () => ({
    dragover: false,
    uploadedFile: null,
    urlImage: null,
    error: false,
    errorImage: false,
  }),
  mounted() {
    this.previewUrlImage();
  },
  methods: {
    previewUrlImage() {
      //Si esta en modo de edicion, se copia la url de la imagen a "urlImage"
      //para poder visualizar la imagen en el componente
      if (this.$route.params.id) {
        if (typeof this.value === "string" || this.value instanceof String) {
          this.urlImage = this.value;
        }
      }
    },
    onDrop(e) {
      this.dragover = false;
      Array.from(e.dataTransfer.files).forEach((element) => {
        if (this.validateImage(element)) {
          this.loadImage(element);
        }
      });
    },
    onFileChanged(e) {
      if (this.validateImage(e.target.files[0])) {
        this.loadImage(e.target.files[0]);
      }
    },
    loadImage(file) {
      this.uploadedFile = file;
      this.error = false;
      this.previewImage();
    },
    validateImage(file) {
      const type = file.type.split("/").pop().toLowerCase();
      const size = file.size / 1024 / 1024;
      if (type != "jpeg" && type != "jpg" && type != "png") {
        this.errorImage = true;
        return false;
      }
      if (size >= this.maxImageSize) {
        this.errorImage = true;
        return false;
      }
      this.errorImage = false;
      return true;

      // El codigo comentado valida las medidas de una imagen
      /*       const img = new Image();
      const objectUrl = window.URL.createObjectURL(file);
      img.src = objectUrl;
      
      const self = this;
      img.onload = function () {
        if (this.width > self.maxImageWidth) {
          self.errorImage = true
        }
        if (this.height > self.maxImageHeight) {
          self.errorImage = true
        }
        window.URL.revokeObjectURL(objectUrl);
      }; */
    },
    onButtonClick() {
      this.$refs.uploader.click();
    },
    previewImage() {
      let formData = new FormData();
      formData.append("file", this.uploadedFile);
      formData.append("keyName", this.keyName);
      this.API.helpers.uploadImage(formData).then((response) => {
        this.urlImage = response.url;
        this.$emit("update:url-image", response.url);
        this.$emit("input", this.uploadedFile);
      });
    },
    deleteImage() {
      this.uploadedFile = null;
      this.urlImage = null;
    },

    validate() {
      this.error = this.urlImage ? false : true;
      return !this.error;
    },
    t(key, options = {}) {
      return this.$t(`designer.upload.${key}`, options);
    },
  },
};
</script>

<style></style>
